module.exports = __webpack_public_path__ + "img/skytte-grey.371fe9f9.png";